export default "__VITE_ASSET__cs1P27EC__"